import chaseIcon from "@/shared/assets/account_logos/chase.svg";
import citiIcon from "@/shared/assets/account_logos/citi.png";
import fidelityIcon from "@/shared/assets/account_logos/fidelity.svg";
import metlifeIcon from "@/shared/assets/account_logos/metlife.svg";
import pncIcon from "@/shared/assets/account_logos/pnc.svg";
import schwabIcon from "@/shared/assets/account_logos/schwab.svg";
import vanguardIcon from "@/shared/assets/account_logos/vanguard.svg";
import wellsFargoIcon from "@/shared/assets/account_logos/wells-fargo.svg";

const INSTITUTION_LOGOS: Record<string, string> = {
  chase: chaseIcon,
  citi: citiIcon,
  citibank: citiIcon,
  fidelity: fidelityIcon,
  metlife: metlifeIcon,
  pnc: pncIcon,
  schwab: schwabIcon,
  "charles schwab": schwabIcon,
  vanguard: vanguardIcon,
  "wells fargo": wellsFargoIcon,
  wellsfargo: wellsFargoIcon,
};

export function getInstitutionLogo(itemName: string): string | null {
  if (!itemName) return null;
  const name = itemName.toLowerCase();

  for (const [key, logo] of Object.entries(INSTITUTION_LOGOS)) {
    if (name.includes(key)) return logo;
  }

  return null;
}
